var React = require('react');

function ShareIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#fff;stroke:#1d2340;}.b{fill:#1d2340;}.c{stroke:none;}.d{fill:none;}")),React.createElement("g",{"className":"a","key":1},[React.createElement("circle",{"className":"c","cx":"16","cy":"16","r":"16","key":0}),React.createElement("circle",{"className":"d","cx":"16","cy":"16","r":"15.5","key":1})]),React.createElement("path",{"className":"b","d":"M7.221,6.565a1.961,1.961,0,0,0-1.227.429L3.892,5.68a1.981,1.981,0,0,0,0-.855l2.1-1.314A1.966,1.966,0,1,0,5.3,2.4L3.2,3.711a1.969,1.969,0,1,0,0,3.082L5.3,8.107A1.97,1.97,0,1,0,7.221,6.565Z","transform":"translate(11 11)","key":2})]);
}

ShareIcon.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = ShareIcon;

ShareIcon.default = ShareIcon;
